import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { ApiError } from '../api/client';

export function Loading() {
  const { t } = useTranslation();
  return <div className="loading">{t('common.loading')}</div>;
}

export function ErrorState({ error, onRetry }: { error: unknown; onRetry?: () => void }) {
  const { t } = useTranslation();
  return (
    <div className="empty">
      {error instanceof ApiError ? error.userMessage : t('errors.unknown')}
      {onRetry && (
        <>
          <br />
          <button type="button" className="btn" onClick={onRetry}>
            {t('common.retry')}
          </button>
        </>
      )}
    </div>
  );
}

export function TableEmpty({ children }: { children: ReactNode }) {
  return (
    <div className="table-wrap">
      <div className="empty">{children}</div>
    </div>
  );
}
